// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainReport_paper__uBIV7 {
    width: 75vw;
    margin: 1rem auto;
    padding: 4rem 0;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding-top: 0;
    border-radius: 10px !important;
}

.MainReport_Navigations__y8jet {
    display: flex;
    width: 100%;
    /* justify-content: s; */
    border-radius: 10px !important;
}

.MainReport_paper2__FpgkN {
    width: 90%;
    margin: 1rem auto;
    padding: 0;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

}

.MainReport_topNavigation__5kPWJ {
    width: 33.33%;
    font-size: 1.2rem;
    color: #fff;
    background: #461088;
    padding: 0.6rem 0;
    border-right: 1px solid gray;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
}

.MainReport_btns__dKDu0 {
    margin-left: 1rem;
}

.MainReport_btn__pl2ab {
    color: #fff !important;
    background: #461088 !important;
    border: 5px solid #461088;
    text-transform: none !important;
    width: 80% !important;
    padding: 0.6rem 0 !important;
    border-radius: 12px !important;
    font-size: 1.2rem !important;
    font-weight: bold !important;
    cursor: pointer;
}

.MainReport_active__\\+n\\+Ej {
    background: #fff !important;
    color: #461088 !important;

}

.MainReport_btn__pl2ab:hover {
    background: #fff !important;
    color: #461088 !important;
}

.MainReport_bottomText__kkv4- {
    width: 90%;
    margin: 0 auto;
    text-align: justify;
    color: #461088;
    font-weight: 500;

}


@media (max-width: 600px) {
    .MainReport_paper__uBIV7 {
        width: 95vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/MainReport.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;;AAE/C;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,+BAA+B;IAC/B,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;;AAE7B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;;AAEpB;;;AAGA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".paper {\n    width: 75vw;\n    margin: 1rem auto;\n    padding: 4rem 0;\n    background: #fff;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n    padding-top: 0;\n    border-radius: 10px !important;\n}\n\n.Navigations {\n    display: flex;\n    width: 100%;\n    /* justify-content: s; */\n    border-radius: 10px !important;\n}\n\n.paper2 {\n    width: 90%;\n    margin: 1rem auto;\n    padding: 0;\n    background: #fff;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n\n}\n\n.topNavigation {\n    width: 33.33%;\n    font-size: 1.2rem;\n    color: #fff;\n    background: #461088;\n    padding: 0.6rem 0;\n    border-right: 1px solid gray;\n    text-align: center;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.btns {\n    margin-left: 1rem;\n}\n\n.btn {\n    color: #fff !important;\n    background: #461088 !important;\n    border: 5px solid #461088;\n    text-transform: none !important;\n    width: 80% !important;\n    padding: 0.6rem 0 !important;\n    border-radius: 12px !important;\n    font-size: 1.2rem !important;\n    font-weight: bold !important;\n    cursor: pointer;\n}\n\n.active {\n    background: #fff !important;\n    color: #461088 !important;\n\n}\n\n.btn:hover {\n    background: #fff !important;\n    color: #461088 !important;\n}\n\n.bottomText {\n    width: 90%;\n    margin: 0 auto;\n    text-align: justify;\n    color: #461088;\n    font-weight: 500;\n\n}\n\n\n@media (max-width: 600px) {\n    .paper {\n        width: 95vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `MainReport_paper__uBIV7`,
	"Navigations": `MainReport_Navigations__y8jet`,
	"paper2": `MainReport_paper2__FpgkN`,
	"topNavigation": `MainReport_topNavigation__5kPWJ`,
	"btns": `MainReport_btns__dKDu0`,
	"btn": `MainReport_btn__pl2ab`,
	"active": `MainReport_active__+n+Ej`,
	"bottomText": `MainReport_bottomText__kkv4-`
};
export default ___CSS_LOADER_EXPORT___;
